export default __webpack_public_path__ + "static/media/chevron-right.27d1578f.svg";